import React from "react";
import "./Footer.css"; // Assume you have a separate CSS file for the footer
import { Link } from "react-router-dom";
import { BlueskyIcon } from "./Icons";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-first-half">
          <Link to="/" className="logo-link-footer">
            <img src="/logo1-inverted.png" alt="Logo of CACI in Footer" className="logo-foot" />
          </Link>
          <div className="footer-first-half-left">
            <div className="footer-links">
              <p>
                CONTACT: hbw@iu.edu
              </p>
            </div>
            <div className="social-icons-footer">
              <a href="https://bsky.app/profile/hbw" className="social-icon" target="_blank" rel="noopener noreferrer" aria-label="Follow Black Lit Network on Bluesky">
                <BlueskyIcon />
              </a>
              <a href="https://x.com/hbw" className="social-icon" target="_blank" rel="noopener noreferrer" aria-label="Follow Black Lit Network on Twitter">
                <i className="fa fa-twitter" aria-hidden="true"></i>
              </a>
              <a href="https://www.facebook.com/people/hbw" className="social-icon" target="_blank" rel="noopener noreferrer" aria-label="Follow Black Lit Network on Facebook">
                <i className="fa fa-facebook" aria-hidden="true"></i>
              </a>
              <a href="https://www.instagram.com/hbw" className="social-icon" target="_blank" rel="noopener noreferrer" aria-label="Follow Black Lit Network on Instagram">
                <i className="fa fa-instagram" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="subscription-license-container">
          <p>
            © {new Date().getFullYear()} History of Black Writing
          </p>

          <p className="license-text">
            Licensed under{" "}
            <a href="https://creativecommons.org/licenses/by-nc-sa/4.0/" target="_blank" rel="noopener noreferrer">CC BY-NC-SA 4.0</a>
            <img className="license-icon" src="https://mirrors.creativecommons.org/presskit/icons/cc.svg" target="_blank" rel="noopener noreferrer" alt="Logo of Creative Commons"></img>
            <img className="license-icon" src="https://mirrors.creativecommons.org/presskit/icons/by.svg" target="_blank" rel="noopener noreferrer" alt="Logo of Creative Commons BY"></img>
            <img className="license-icon" src="https://mirrors.creativecommons.org/presskit/icons/nc.svg" target="_blank" rel="noopener noreferrer" alt="Logo of Creative Commons NonCommercial"></img>
            <img className="license-icon" src="https://mirrors.creativecommons.org/presskit/icons/sa.svg" target="_blank" rel="noopener noreferrer" alt="Logo of Creative Commons ShareAlike"></img>
          </p>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="footer-funding">
          <p>Funded by</p>
          <div className="fund-img">
            <img
              src="/mellon.svg"
              alt="Logo of Mellon Foundation"
              title="Mellon Foundation"
              onClick={() => window.open("https://mellon.org", "_blank")}
              style={{ cursor: "pointer" }}
            />

          </div>
        </div>
        <div className="footer-partners">
          <p>Partnered Universities</p>
          <div className="foot-partner-img">
            <img
              className="partner-logo"
              src="/IULogo.png"
              alt="Logo of Indiana University (IU)"
              title="Indiana University (IU)"
              onClick={() => window.open("https://www.iu.edu", "_blank")}
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
